import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'common/lib/numeral'
import actions from 'client/actions'
import DocumentTitle from 'react-document-title'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  Tooltip
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Contact from 'client/components/Contact';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Tooltip
);

const BarChart = ({ now, potential, labels }) => {
    const options = {
        animation: false,
        plugins: {
            legend: {
                display: false
            }
        },
        barPercentage: 0.8,
        scales: {
            y: {
                ticks: {
                    font: {
                        family: 'Outfit',
                        weight: 300,
                    }
                },
                grid: {
                    color: '#F4EAE1',
                    lineWidth: '0.8'
                }
            },
            x: {
                ticks: {
                    font: {
                        family: 'Outfit',
                        weight: 300,
                    }
                },
                grid: {
                display: false
                }
            }
        }
    }

    const chartData = {
        labels: labels,
        datasets: [{
            label: 'I dag',
            data: now,
            borderRadius: 5,
            backgroundColor: '#6D8299',
        },
        {
            label: 'Efter rentable tiltag',
            data: potential,
            borderRadius: 5,
            backgroundColor: '#4F6C65',
        }
    ],
    }

    return (
        <Bar data={chartData} options={options} />
    )
}
class Energy extends Component {

    constructor (props) {
        super(props)
        this.energyColumn = this.energyColumn.bind(this)
        this.formatEnergyExpensePerYear = this.formatEnergyExpensePerYear.bind(this)
    }

    energyColumn (className, object) {
        return <div className="energy-column">
            <div className={"bg-" + className}>
                <span className="label-char-sm">{object.char}</span>
                {object.year ? <span className="label-year">{object.year}</span> : null}
            </div>
        </div>
    }

    componentDidMount() {
        const { dispatch, setBreadcrumb } = this.props
        dispatch(setBreadcrumb('Energi'));
    }

    formatEnergyExpensePerYear(expense, totalArea) {
        if (!expense || !totalArea) {
            return null;
        }
        return numeral(expense / totalArea / 15).format('0,0') + ' kr.';
    }
  
    render () {
        const {
            plan, params: { customer_id },
            parts, estimates, years, route,
            classes,
        } = this.props
        const { internal_contact = {} } = plan
        const energyOptions = {
            'a2020': {char: 'A', year: 2020},
            'a2015': {char: 'A', year: 2015},
            'a2013': {char: 'A', year: 2013},
            'a2010': {char: 'A', year: 2010},
            'b': {char: 'B'},
            'c': {char: 'C'},
            'd': {char: 'D'},
            'e': {char: 'E'},
            'f': {char: 'F'},
            'g': {char: 'G'}
        }
    const energyTypes = {1: 'm3 naturgas', 2: 'm3', 3: 'kWh elektricitet', 4: 'kWh fra solceller', 5: 'kWh', 6: 'Liter', 7: 'Mwh fjernvarme'}

        return (
            <div>
                <DocumentTitle title={ route.title } />

                <Grid container alignItems="stretch" spacing={3}>
                    <Grid item sm={12} md={7} lg={6}>
                        <Paper className={classes.paperWithoutHeight}>
                            <div id="energy-label">
                                <div className="energy-title">
                                    <div>
                                        <Typography className={classes.header} variant="h5">Energimærke</Typography>
                                        <Typography className={classes.energySubTitle} variant="subtitle1">Ejendommen har energimærke:</Typography>
                                    </div>
                                    <div className="energy-column-current">
                                        {plan.energy_label && this.energyColumn(plan.energy_label, energyOptions[plan.energy_label])}
                                    </div>
                                </div>
                                <div className="row grid">
                                    <div className="energy-column-container col-md-12">
                                        {Object.keys(energyOptions).map(e => (
                                            this.energyColumn(e,energyOptions[e])
                                        ))}
                                    </div>
                                </div>
                                {plan.energy_label_potential && <div className="row">
                                    <div className={"arrow-position-" + plan.energy_label_potential}>
                                        <div className="arrow-wrapper">
                                            <div className="arrow-up"/>
                                            <div className="arrow-text">Energimærke<br/>(Potentiale)</div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            <Typography>Energimærkningsrapport {plan.energy_report_number} {plan.energy_report_date && <>(Udløber den {moment(plan.energy_report_date).format('DD. MMMM YYYY')})</>}</Typography>
                            <Typography className={classes.marginBottom}>Data er hentet fra energimærkning. Der tages forbehold for fejl og ændringer</Typography>
                        </Paper>
                        {plan.energy_consumption_new &&
                        <Paper className={`${classes.paperWithoutHeight} ${classes.marginTop}`}>
                            <Typography className={classes.header} variant="h5">Ejendommens energiforbrug</Typography>
                            <div className={classes.chartEnergy}>
                                <div><span className="label label-round label-now">&nbsp;</span>I dag</div>
                                <div><span className="label label-round label-after">&nbsp;</span>Efter rentable tiltag</div>
                            </div>
                            <BarChart now={[parseInt(plan.energy_consumption_new), plan.energy_electricity_purpose]} potential={[parseInt(plan.energy_consumption_new_potential), plan.energy_electricity_purpose_potential]} labels={[energyTypes[plan.energy_type], "El til andet"]}/>
                        </Paper>}
                    </Grid>
                    <Grid item sm={12} md={5} lg={6}>
                        <Paper className={classes.paperWithoutHeight}>
                            <div className={classes.infoTableContainer}>
                                <div className={classes.infoTableHeader}>
                                    <Typography className={`${classes.greyText} ${classes.oneThird}`}></Typography>
                                    <Typography className={`${classes.blueTextHeader} ${classes.oneThird}`}>
                                        Nuværende
                                    </Typography>
                                    <Typography className={`${classes.blueTextHeader} ${classes.oneThird}`}>
                                        Potentiale
                                    </Typography>
                                </div>
                                <div className={classes.infoTable}>
                                    <Typography className={`${classes.greyText} ${classes.oneThird}`}>Samlet CO2-udledning</Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        {plan.energy_emission ? numeral(plan.energy_emission).format('0.00') : 0} ton
                                    </Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        {plan.energy_emission_potential ? <>{numeral(plan.energy_emission_potential).format('0.00')}</> : 0} ton
                                    </Typography>
                                </div>
                                <div className={classes.infoTable}>
                                    <Typography className={`${classes.greyText} ${classes.oneThird}`}>Årligt varmeforbrug</Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { plan.energy_consumption_new ? <>{numeral(plan.energy_consumption_new).format('0,0')} {energyTypes[plan.energy_type]}</> : <>{plan.energy_consumption}</> }
                                    </Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { plan.energy_consumption_new_potential ? <>{numeral(plan.energy_consumption_new_potential).format('0,0')} {energyTypes[plan.energy_type]}</> : <>{plan.energy_consumption_potential}</> }
                                    </Typography>
                                </div>
                                <div className={classes.infoTable}>
                                    <Typography className={`${classes.greyText} ${classes.oneThird}`}>El til andet</Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { plan.energy_electricity_purpose ? numeral(plan.energy_electricity_purpose).format('0,0') : 0 } kWh
                                    </Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { plan.energy_electricity_purpose_potential ? numeral(plan.energy_electricity_purpose_potential).format('0,0') : 0 } kWh
                                    </Typography>
                                </div>
                                <div className={classes.infoTable}>
                                    <Typography className={`${classes.greyText} ${classes.oneThird}`}>Samlet årlig energiudgift</Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { numeral(plan.energy_expense).format('0,0') } kr.
                                    </Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { numeral(plan.energy_expense_potential).format('0,0') } kr.
                                    </Typography>
                                </div>
                                <div className={classes.infoTable}>
                                    <Typography className={`${classes.greyText} ${classes.oneThird}`}>Energiudgift pr. m<sup>2</sup> / pr. år</Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { this.formatEnergyExpensePerYear(plan.energy_expense, plan.total_area) }
                                    </Typography>
                                    <Typography className={`${classes.blueText} ${classes.oneThird}`}>
                                        { this.formatEnergyExpensePerYear(plan.energy_expense_potential, plan.total_area) }
                                    </Typography>
                                </div>
                            </div>
                            <Typography className={`${classes.marginTop} ${classes.fontTwelve} ${classes.greyText}`} paragraph>
                                Ifølge dit energimærke, betaler du hvert år mere i energiudgifter end du behøver.
                            </Typography>
                            <Typography className={classes.energyText} paragraph>
                                Der er mulighed for en årlig besparelse på:
                            </Typography>
                            {<Typography className={classes.marginTen} variant="h4">
                                {plan.energy_yearly_saving ? numeral(plan.energy_yearly_saving).format('0,0') : 0} kr.
                            </Typography>}
                            <Typography className={`${classes.greyText} ${classes.marginTen}`} paragraph>
                                {plan.energy_label_text ? plan.energy_label_text : 'Udarbejdelse af løsningsforslag for energioptimering tilbydes særskilt'}
                            </Typography>
                        </Paper>
                        <Contact
                            title={"Kontakt Plan1 for at høre om mulighederne"}
                            name={internal_contact.name}
                            email={internal_contact.email}
                            phone={internal_contact.phone}
                            src={internal_contact.s3_image_id ? `https://ik.imagekit.io/aw3ddey5g/${internal_contact.s3_image_id}?tr=w-200` : null}
                            variant="h5"
                            paperClasses={`${classes.hidePrint} ${classes.paperWithoutHeight} ${classes.marginTop}`}
                        />
                    </Grid>
                </Grid>
                                    {/* <div className="col-md-6">
                                        <h4 className="text-muted">Årligt varmeforbrug (nuværende)</h4>
                                        <h3>
                                            {
                                                plan.energy_consumption
                                                  ? numeral(plan.energy_consumption).format('0.00')
                                                  : 0
                                            }
                                            &nbsp;MWh
                                        </h3>
                                    </div>
                                    <div className="col-md-6">
                                        <h4 className="text-muted">Samlet CO2 udledning (nuværende)</h4>
                                        <h3>
                                          {
                                            plan.energy_emission ? numeral(plan.energy_emission).format('0.00') : 0
                                          }
                                          &nbsp;ton
                                        </h3>
                                    </div>
                                    <div className="col-md-6">
                                        <h4 className="text-muted">Årligt varmeforbrug (potentiale)</h4>
                                        <h3 className="green-text">
                                          {
                                            plan.energy_consumption_potential
                                              ? <span>{numeral(plan.energy_consumption_potential).format('0.00')} MWh</span>
                                              : "..."
                                          }
                                        </h3>
                                    </div>
                                    <div className="col-md-6">
                                        <h4 className="text-muted">Samlet CO2 udledning (potentiale)</h4>
                                        <h3 className="green-text">
                                            {
                                                plan.energy_emission_potential
                                                  ? <span>{numeral(plan.energy_emission_potential).format('0.00')} ton</span>
                                                  : "..."
                                            }
                                        </h3>
                                    </div>
                                    <p className="text-muted-dark">Energimærkningsrapport {plan.energy_report_number} (Udløber den {moment(plan.energy_report_date).format('DD. MMMM YYYY')})</p>
                                    <p className="text-muted text-muted-small">
                                      Data er hentet fra energimærkning<br/>
                                      Der tages forbehold for fejl og ændringer
                                    </p>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </section> */}

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        plan: state.data.customer.plan,
        parts: state.data.customer.parts,
        estimates: state.data.customer.estimates,
        years: state.data.years.years,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
        setBreadcrumb: actions.setBreadcrumb,
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Energy))
